import { Grid } from '@mui/material';
import AuthCarousel from 'components/shared/Carousels/AuthCarousel';
import createGuest from 'ipn-cross-domain-storage/guest';
import FormSection from './FormSection/FormSection';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from 'context/auth-context';
import { useLocation } from 'react-router';
import { LOGIN_ERROR_TYPES, USER_ROLES } from 'helpers/constants';
import { APP_ROUTES, LAYOUT_ROUTES } from 'routes';
import * as JWT from 'jsonwebtoken';
import { useHistory } from 'react-router';
import { Set_Name } from 'resolvers/Set_Name';
import { Token } from 'resolvers/Token';
import './Login.css';
import { Auth } from 'lib/api/';
import { LoaderPage } from 'pages/Loader.page';
import LoaderComponent from '../signup/LoaderComponent';

const Login = () => {
    const history = useHistory();
    const [isLoadingPage, setIsLoadingPage] = useState(false);
    const [isLoadingResource, setIsLoadingResource] = useState(false);
    const [crossDomainValue, setCrossDomainValue] = useState({});
    const { loginUser, setDecodeState } = useContext(AuthContext);
    const location = useLocation();
    const qs = new URLSearchParams(location.search);
    const customerId = qs.get('customerId');
    const errorType = qs.get('errorType');

    useEffect(() => {
        if (customerId) {
            setIsLoadingPage(true);
            try {
                const crossDomainStorage = createGuest(process.env.REACT_APP_AR_FRONTEND_URL);
                crossDomainStorage.get('dashboard.state', (error, value) => {
                    if (error) {
                        setIsLoadingPage(false);
                    } else {
                        setCrossDomainValue(JSON.parse(value));
                    }
                });
            } catch (error) {
                setIsLoadingPage(false);
            }
        }
    }, [customerId]);

    useEffect(() => {
        const validateToken = async () => {
            setIsLoadingPage(true);
            const { accessToken } = crossDomainValue;
            try {
                const token = await Auth.validateToken({ accessToken, customerId });
                // TODO: Change for function
                loginUser(token);
                Token(token);
                Set_Name(token);
                const tokenUser = JWT.decode(token.token);
                setDecodeState({
                    ...tokenUser,
                    loaded: true
                });

                if (tokenUser.id_role === USER_ROLES.CARD_HOLDER) return history.replace(LAYOUT_ROUTES.CARDS);
                return history.replace(APP_ROUTES.DASHBOARD);
            } catch (error) {
                setIsLoadingPage(false);
                switch (error?.response?.data?.type) {
                    case LOGIN_ERROR_TYPES.NO_BUSINESS:
                        return history.replace('/login?errorType=no_business');
                    case LOGIN_ERROR_TYPES.INVALID_TOKEN:
                        return history.replace('/login?errorType=invalid_token');
                    default:
                        return history.replace('/login?errorType=invalid_token');
                }
            }
        };
        if (customerId && crossDomainValue?.accessToken) {
            validateToken();
        }
    }, [customerId, crossDomainValue]);

    return (
        <>
            {isLoadingPage ? (
                <LoaderPage />
            ) : (
                <Grid
                    container
                    spacing={2}
                    alignItems="stretch"
                    sx={{
                        display: { lg: 'flex', md: 'flex', sm: 'block', xs: 'block' },
                        marginLeft: { lg: '-16px', md: '-16px', sm: '0px', xs: '0px' },
                        width: { sm: '100%', xs: '100%' }
                    }}>
                    <Grid
                        item
                        xs={8}
                        sm={12}
                        md={8}
                        xl={8}
                        sx={{
                            display: { lg: 'block', md: 'block', sm: 'none', xs: 'none' }
                        }}>
                        <AuthCarousel />
                    </Grid>
                    <Grid
                        className="login-section"
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        xl={4}
                        sx={{
                            paddingLeft: {
                                lg: '16px !important',
                                md: '16px !important',
                                sm: '0px !important',
                                xs: '0px !important'
                            }
                        }}>
                        {isLoadingResource && <LoaderComponent />}
                        <FormSection loginError={errorType} isLoading={isLoadingResource} setIsLoading={setIsLoadingResource} />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default Login;
